import { Box, Button, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { Wallet } from "src/components/icons";
import { connectWallet } from "src/wallet-connection/handle-connection";

const useStyles = makeStyles((theme) => ({
  button: {
    border: 0,
    textTransform: "capitalize",
    padding: theme.spacing(1.2, 1),
    minWidth: "163px",
    background: "linear-gradient(100.42deg, #2C85EE 16.07%, #4FB5FF 79.2%)",
    [theme.breakpoints.between("1053", "1099")]: {
      minWidth: 118,
      padding: "5px 8px",
    },
    [theme.breakpoints.between("0", "420")]: {
      minWidth: 118,
      padding: "5px 8px",
    },
  },
  inner: {
    [theme.breakpoints.between("1053", "1099")]: {
      width: "70px",
    },
    [theme.breakpoints.between("0", "420")]: {
      width: "70px",
    },
  },
}));

export default function ConnectWalletButton({ innerProps, ...props }) {
  const cls = useStyles();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  return (
    <Button
      {...props}
      size="small"
      className={clsx(cls.button, props?.className)}
      variant="outlined"
      onClick={() => connectWallet(dispatch, enqueueSnackbar)}
    >
      <Box display="flex" alignItems="center">
        <Wallet size={22} />
        <Box
          {...innerProps}
          pl={1.5}
          display="flex"
          alignItems="center"
          className={clsx(cls.inner, innerProps?.className)}
        >
          <span style={{ fontSize: 15, lineHeight: "18px" }}>Connect Wallet</span>
        </Box>
      </Box>
    </Button>
  );
}
